module.exports = __webpack_public_path__ + "static/media/conecte-mobile.80ae7139.png";